const $ = require("jquery");
const _ = require("lodash");

class StateField {
	constructor (id) {
		this.id = id;
		this.$root = this.getRoot();
		this.$previous = this.getPrevious();
		this.$parent = this.getParent();
		this.country = this.getCountry();
		this.countriesWithStates = [];
		this.setupCountryChangeListener();
		this.refresh();
	}

	getRoot () {
		return this.$root ? this.$root : $(`#${this.id}`);
	}

	getSelect () {
		return this.getRoot().find("select");
	}

	getParent () {
		return this.$parent ? this.$parent : this.getRoot().parent();
	}

	getPrevious () {
		return this.$previous ? this.$previous : this.getRoot().prev();
	}

	hide () {
		this.$root = this.getRoot().detach();
	}

	show (country) {
		if (country === this.country) {
			return;
		}

		this.country = country;

		const states = this.getStates(country);

		this.getSelect().empty();
		_.toPairs(states).forEach(([value, label]) => {
			this.getSelect().append(
				`<option value="${value}">${label}</option>`
			);
		});

		if (!_.isEmpty(states)) {
			this.getSelect().prop("required", true);

			if (this.getPrevious().length) {
				this.getPrevious().after(this.getRoot());
			} else if (this.getParent().length) {
				this.getParent().prepend(this.getRoot());
			}
		} else {
			this.getSelect().prop("required", false);
		}
	}

	refresh (country) {
		this.hide();
		this.show(country);
	}

	getCountrySelectId () {
		return this.getRoot().data("countryselectid");
	}

	getCountrySelect () {
		return $(`#${this.getCountrySelectId()}`);
	}

	getCountry () {
		return this.getCountrySelect().val();
	}

	getStates (country) {
		const countryWithStates = _.find([
			..._.map(this.countriesWithStates, c => ({
				...c,
				states: _.reduce(
					c.states,
					(sum, s) => ({ ...sum, [s]: s }),
					{}
				)
			})),
			{ name: "United States", states: this.getRoot().data("statesus") },
			{ name: "Canada", states: this.getRoot().data("statesca") }
		], countryWithStates => countryWithStates.name === country);

		return countryWithStates ? countryWithStates.states : {};
	}

	setupCountryChangeListener () {
		this.getCountrySelect().on("change", e => this.onCountryChange(e));
	}

	onCountryChange (e) {
		const country = $(e.target).val();
		this.refresh(country);
	}
}

StateField.init = () => {
	const objects = [];

	$('[data-component="state-field"]').each((i, e) => {
		const id = $(e).attr("id");
		objects.push(new StateField(id));
	});

	return objects;
}

module.exports = StateField;
